import { Box } from "@mui/material";
import StlapFooter from "../../CustomComponents/StlapFooter";
import LegalDetail from "./applicantDetailsComponent/legalDetail";
import ApplicationInfo from "./applicantDetailsComponent/ApplicationInfo";
import TechnicalDetail from "./applicantDetailsComponent/TechnicalDetail";
import RecommendationDetail from "./applicantDetailsComponent/RecommendationDetail";
import HouseholdAssessmentDetail from "./applicantDetailsComponent/HouseholdAssessmentDetail";
import HouseholdAssessmentExpenses from "./applicantDetailsComponent/HouseholdAssessmentExpenses";
import HouseholdAsset from "./applicantDetailsComponent/HouseholdAsset";
import FoirDetails from "./applicantDetailsComponent/FoirDetails";
import BankDetails from "./applicantDetailsComponent/BankDetails";
import Deviations from "./applicantDetailsComponent/Deviations";
import QueryList from "./applicantDetailsComponent/QueryList";
import RCUDetails from "./applicantDetailsComponent/RCUDetails";
import BusinessIncomeAssessmentDetail from "./applicantDetailsComponent/BusinessIncomeAssement/BusinessIncomeAssessmentDetail";
import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { initialAppInfoValues } from "./ApplicationInfoHelper";
import PageNotFound from "../../CustomComponents/PageNotFound";
import CollateralDetails from "./CollateralDetails";
import ApplicationFeeList from "./applicantDetailsComponent/ApplicationFeeList";
import { useDispatch } from "react-redux";
import { SpinnerReduerAction } from "../../Store/spinner/SpinnerReducer";
import CustomSpinner from "../../CustomComponents/CustomSpinner";
import CommonInformationDialog from "../../CustomComponents/CommonInformationDialog";
import CollateralAddressInformation from "./applicantDetailsComponent/CollateralAddressInformation";
import SanctionRemarks from "./applicantDetailsComponent/SanctionRemarks";
import LegalPropertyAddressInformation from "./applicantDetailsComponent/LegalPropertyAddressInformation";
import TechnicalPropertyAddressInformation from "./applicantDetailsComponent/TechnicalPropertyAddressInformation";
import TakeoverPropertyOwnership from "./applicantDetailsComponent/TakeoverPropertyOwnership";
import TakeOverDetails from "./applicantDetailsComponent/TakeOverDetails";
import DynamicTemplateDocuments from "./applicantDetailsComponent/DynamicTemplateDocuments";
import TemplateDocuments from "./applicantDetailsComponent/TemplateDocuments";
import DynamicTemplateFormulaInformation from "./applicantDetailsComponent/DynamicTemplateFormulaInformation";
import EndUseDetails from "./applicantDetailsComponent/EndUseDetails";
import TakeOverDmsDetails from "./applicantDetailsComponent/TakeOverDmsDetails";
import DynamicTemplateFields from "./applicantDetailsComponent/DynamicTemplateFields";
import NhbAddress from "./applicantDetailsComponent/NhbAddress";
import TakeOverDocList from "./applicantDetailsComponent/TakeOverDocList";
import DynamicTemplate from "./applicantDetailsComponent/DynamicTemplate";
import BCORecommendations from "./applicantDetailsComponent/BCORecommendations";

const ApplicantDetails = () => {
  const dispatch = useDispatch();
  const { internalApplicationId } = useParams();
  const [invalidID, setInvalidID] = useState(false);
  const [applicationInformation, setApplicationInformation] =
    useState(initialAppInfoValues);

  useEffect(() => {
    loadApplicantInformation();
  }, []);

  const loadApplicantInformation = async () => {
    dispatch(SpinnerReduerAction.updateSpinnerFlag(true));
    let newAxiosBase = { ...axios };
    newAxiosBase.defaults.baseURL =
      process.env.REACT_APP_STLAP_LOS_DATA_BACKEND;
    try {
      await newAxiosBase
        .post("/stlap/getApplicantDetailsById", {
          internalApplicationId: internalApplicationId,
        })
        .then((res) => {
          setApplicationInformation(res.data);
        });
    } catch {
      setInvalidID(true);
    }
    dispatch(SpinnerReduerAction.updateSpinnerFlag(false));
  };

  return (
    <>
      <CustomSpinner />
      {invalidID ? (
        <PageNotFound />
      ) : (
        <Box style={{ minHeight: "calc(100vh - 120px)" }}>
          <ApplicationInfo applicationInformation={applicationInformation} />
          <TechnicalDetail
            technicalDetailsList={applicationInformation["technicalDetails"]}
          />
          <RecommendationDetail
            ccoRecommendation={applicationInformation["ccoRecommendation"]}
          />
          <LegalDetail
            legalDetailsList={applicationInformation["legalDetails"]}
          />
          <HouseholdAssessmentDetail
            householdAssessmentDetails={
              applicationInformation["householdAssessmentDetails"]
            }
          />
          <HouseholdAssessmentExpenses
            householdAssessmentExpenses={
              applicationInformation["householdAssessmentExpenses"]
            }
          />
          <HouseholdAsset
            householdAsset={applicationInformation["householdAsset"]}
          />
          <FoirDetails foirDetails={applicationInformation["foirDetails"]} />
          <BankDetails bankDetails={applicationInformation["bankDetails"]} />
          <Deviations deviations={applicationInformation["deviations"]} />
          <QueryList queryDetails={applicationInformation["queryDetails"]} />
          <RCUDetails rcuDetailsList={applicationInformation["rcuDetails"]} />
          <BusinessIncomeAssessmentDetail
            businessIncomeAssessment={
              applicationInformation["businessIncomeAssessment"]
            }
          />
          <CollateralDetails
            collateralInformationList={
              applicationInformation["collateralDetails"]
            }
          />
          <CollateralAddressInformation
            collateralAddressInformationData={
              applicationInformation["collateralAddress"]
            }
          />
          <ApplicationFeeList
            applicationFeeDetails={applicationInformation["applicationFee"]}
          />
          <SanctionRemarks
            sanctionRemarksColumn={applicationInformation["sanctionRemarks"]}
          />
          <LegalPropertyAddressInformation
            legalAddressInfoList={
              applicationInformation["legalPropertyAddress"]
            }
          />
          <TechnicalPropertyAddressInformation
            technicalAddressInfoList={
              applicationInformation["technicalPropertyAddress"]
            }
          />
          <TakeoverPropertyOwnership
            takeoverPropOwnerList={
              applicationInformation["takeoverPropertyOwnership"]
            }
          />
          <TakeOverDetails
            takeOverDetails={applicationInformation["takeOverDetails"]}
          />
          <TakeOverDmsDetails
            takeOverDmsDetails={applicationInformation["takeOverDmsDetails"]}
          />
          <TakeOverDocList
            takeOverDocList={applicationInformation["takeOverDocList"]}
          />
          <DynamicTemplate
            dynamicTemplateList={applicationInformation["dynamicTemplate"]}
          />
          <DynamicTemplateDocuments
            dynamicTemplateDocumentList={
              applicationInformation["dynamicTemplateDocuments"]
            }
          />
          <DynamicTemplateFields
            dynamicTemplateFieldsList={
              applicationInformation["dynamicTemplateFields"]
            }
          />
          <DynamicTemplateFormulaInformation
            dynamicTemplateFormulasList={
              applicationInformation["dynamicTemplateFormulas"]
            }
          />
          <TemplateDocuments
            templateDocumentList={applicationInformation["templateDocuments"]}
          />
          <NhbAddress nhbAddressList={applicationInformation["nhbAddress"]} />
          <BCORecommendations
            BcoRecommendationList={applicationInformation["bcoRecommendations"]}
          />
          <EndUseDetails
            endUseDetailsList={applicationInformation["endUseDetails"]}
          />
          <CommonInformationDialog />
        </Box>
      )}
      <StlapFooter />
    </>
  );
};

export default ApplicantDetails;
